export const font = "futura-pt-condensed, sans-serif;";
export const resetStatusTimer = 15;
export const checkingForNewVersionTimer = 60;
